module.exports = __webpack_public_path__ + "assets/img/light-shadow-2-5ec980f1.png";